/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IdentitySourceName } from './IdentitySourceName';
import {
    IdentitySourceNameFromJSON,
    IdentitySourceNameFromJSONTyped,
    IdentitySourceNameToJSON,
} from './IdentitySourceName';

/**
 * 
 * @export
 * @interface AccessRequestAppExternalConnection
 */
export interface AccessRequestAppExternalConnection {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestAppExternalConnection
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestAppExternalConnection
     */
    name?: string;
    /**
     * 
     * @type {IdentitySourceName}
     * @memberof AccessRequestAppExternalConnection
     */
    source: IdentitySourceName;
}

/**
 * Check if a given object implements the AccessRequestAppExternalConnection interface.
 */
export function instanceOfAccessRequestAppExternalConnection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function AccessRequestAppExternalConnectionFromJSON(json: any): AccessRequestAppExternalConnection {
    return AccessRequestAppExternalConnectionFromJSONTyped(json, false);
}

export function AccessRequestAppExternalConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestAppExternalConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'source': IdentitySourceNameFromJSON(json['source']),
    };
}

export function AccessRequestAppExternalConnectionToJSON(value?: AccessRequestAppExternalConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'source': IdentitySourceNameToJSON(value.source),
    };
}

